import BrandLogo from "@/components/common/BrandLogo";

/** What Nafa Pro promises, in the order the login design lists it. */
const CLAIMS = [
  "Des matières premières aux produits finis",
  "Des stocks valorisés en temps réel",
  "Plusieurs utilisateurs par organisation",
];

/**
 * The dark half of the login screen. It only earns its 520px on a wide
 * viewport, so below `lg` the mark moves above the form instead.
 */
export function BrandPanel() {
  return (
    <aside className="hidden w-[440px] shrink-0 flex-col justify-center gap-6 overflow-hidden bg-brand-black p-14 lg:flex xl:w-[520px]">
      <BrandLogo theme="dark" iconSize={92} textWidth={230} gap={0} />

      <h1 className="max-w-[408px] text-[34px] leading-[48px] font-semibold text-white">
        Vos matières, vos recettes, vos ventes — au même endroit.
      </h1>

      <p className="max-w-[408px] text-[17px] leading-[24px] text-[#c7cbbf]">
        Nafa Pro suit ce que vous achetez, ce que vous transformez et ce que vous vendez, et vous donne à tout moment la
        valeur de vos stocks.
      </p>

      <ul className="flex flex-col gap-3.5">
        {CLAIMS.map((claim) => (
          <li key={claim} className="flex items-center gap-3">
            <span aria-hidden className="size-2.5 shrink-0 rounded-full bg-brand" />
            <span className="text-base leading-[22px] font-medium text-muted">{claim}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
